<template>
  <section class="home-section home-control mb-3 mb-md-5">
    <div class="container">
      <div class="section-head mb-5">
        <div class="service-head-bg">
          <img
            src="@/assets/images/service-head-bg-3.jpg"
            alt
            class="img-fluid"
          />
        </div>

        <div class="sec-header">
          <h1 class="title"><span>3.</span>Control de Inventario</h1>
          <h2 class="sec-subtitle">Registro y clasificación.</h2>

          <div class="section-head-action">
            <router-link
              class="btn btn-outline-light rounded-0 font-weight-bold"
              to="/servicios"
              >+ Info</router-link
            >
          </div>
        </div>
      </div>

      <div class="sec-content">
        <div class="row mb-3">
          <div class="col-md-4 sec-desc">
            <h2 class="sec-desc-title">Gestión de Inventarios</h2>
            <h3 class="sec-desc-subtitle">Métodos de registo.</h3>
            <p class="sec-desc-cont">
              La gestión de inventarios es un punto determinante en el manejo
              estratégico de toda organización. Las tareas correspondientes a la
              gestión de un inventario se relacionan con la determinación de los
              métodos de registro, los puntos de rotación, las formas de
              clasificación y los modelos de reinventario, determinados por los
              métodos de control.
            </p>
          </div>
          <div class="col-md-8 sec-desc">
            <h2 class="sec-desc-title mb-4 mt-md-4 text-center">
              Objetivos Fundamentales
            </h2>
            <div class="row sec-desc-items">
              <div class="col-md-6 left">
                <h3>1. Reducir</h3>
                <h4>al mínimo posible los niveles de existencia.</h4>
              </div>
              <div class="col-md-6 right">
                <h3>2. Asegurar</h3>
                <h4>la disponibilidad de existencias en el momento justo</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeControl',
}
</script>

<style lang="scss" scoped>
.home-control {
  .sec-desc-title {
    margin-bottom: 0;
    font-size: 2.7rem;
    line-height: 2.7rem;
  }
  .sec-desc-subtitle {
    font-size: 1.6rem;
    line-height: 1.6rem;
    font-weight: 200;
    margin-bottom: 1.5rem;
  }
  .sec-desc-items {
    h4 {
      font-size: 1.5rem;
      font-weight: 200;
    }
  }
}
</style>
